module.exports = __webpack_public_path__ + "static/media/acura.ff28ebf2.png";